import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Style from './styles'

const ImportInProgressModal = ({ show, onClose, userEmail }) => {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={t('Importación en curso')}
      size="m"
      actions={
        <Button fullWidth onClick={onClose}>
          {t('Entendido')}
        </Button>
      }
    >
      <Style.Container>
        <Text type="bodyMRegular">
          {t(
            'Tu archivo se ha cargado y se está procesando. Una vez completada la importación, recibirás el resultado por email en '
          )}
          <Text type="bodyMBold" tag="span">
            {userEmail}
          </Text>
          .
        </Text>
        <Text type="bodyMRegular">
          {t('Si se detecta algún error, no dudes en corregir tu archivo y volver a cargarlo.')}
        </Text>
      </Style.Container>
    </Modal>
  )
}

export default ImportInProgressModal
